import { read } from '@/api/rest';

const quality = {
  index: async (params) => await read('/quality?' + params.toString()),
};
export default quality;
